module.exports = __webpack_public_path__ + "static/media/upgrade.e1db75bf.png";